<template>
  <div class="protfolio">
    <div class="gallery">
      <div class="gallery-item" v-for="(item, index) in galleries" :key="index">
        <div>
          <img :src="getImgUrl(item.img)" alt="" />
          <a
            :href="item.url"
            class="info"
            :class="{ url: item.url != 'javascript:void(0)' }"
            :target="setTarget(item.url)"
          >
            <span>{{ item.title }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
      galleries: [
        {
          title: "News website 'Ma3akom.ma'",
          url: "https://ma3akom.ma/",
          img: "ma3akom.png",
        },
        {
          title: "Mobile App 'Remind Me'",
          url: "https://play.google.com/store/apps/details?id=com.belbouk.remind_me",
          img: "Remind Me.png",
        },
        {
          title: "Website 'SafiArt'",
          url: "https://safiart.ma/",
          img: "safiart.png",
        },
        {
          title: "Web App 'Medical Office Management system'",
          url: "javascript:void(0)",
          img: "gcm.png",
        },
        {
          title: "Web App 'Hotel Management system'",
          url: "javascript:void(0)",
          img: "hotel.png",
        },
        {
          title: "Coming Soon",
          url: "javascript:void(0)",
          img: "null.png",
        },
      ],
    };
  },
  methods: {
    getImgUrl(url) {
      if (url.startsWith("http")) return url;
      return require(`@/assets/images/` + url);
    },
    setTarget(url) {
      return url != "javascript:void(0)" ? "_blank" : "_self";
    },
  },
};
</script>
<style lang="scss">
.gallery {
  position: relative;
  flex-grow: 1;
  margin: auto;
  max-width: 100%;
  display: grid;
  grid-gap: 2vmin;
  justify-items: center;
  align-items: center;
  .gallery-item {
    z-index: 1;
    grid-column: span 2;
    margin-bottom: -52%;
    transform: scale(1);
    transition: all 0.25s;
    > div {
      pointer-events: auto;
      transform: rotate(45deg) scale(0.7);
      overflow: hidden;
      border: 1px solid #e4ff00;
    }
    pointer-events: none;
    &:hover {
      z-index: 10;
      transform: scale(1.1);
      .info {
        display: flex;
        &.url {
          cursor: pointer;
        }
      }
    }

    img {
      max-width: 100%;
      transform: rotate(-45deg) scale(1.5);
    }

    .info {
      display: none;
      background-color: rgba(29, 36, 51, 1);
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 10%;
      text-align: center;
      flex-direction: column;
      justify-content: center;
      transform: rotate(-45deg) scale(1.5);
      cursor: not-allowed;
      text-decoration: none;
      color: white;
      font-weight: bold;
    }
  }
}
@media screen and (min-width: 1025px) {
  .gallery {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    grid-template-rows: repeat(4, 1fr);
    .gallery-item {
      &:nth-child(7n + 1) {
        grid-column: 2 / span 2;
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .gallery {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, 1fr);
    .gallery-item {
      &:nth-child(3n + 1) {
        grid-column: 2 / span 2;
      }
    }
  }
}
</style>
